export const BASE_ANIMATION_DURATION_MILLISECONDS = 200;
export const BASE_ANIMATION_DURATION_SECONDS = '0.2s';
export const SHORT_ANIMATION_DURATION_MILLISECONDS = 150;
export const SHORT_ANIMATION_DURATION_SECONDS = '0.15s';
export const DEFAULT_ANIMATION_SLIDE_CURVE = 'cubic-bezier(.38,.86,.8,1.01)';
